<template>
    <div class="payment-fields" :class="!hideFields && 'transfer-form'">
        <v-text-field
            v-model="localData.amount"
            :rules="[valid.amount]"
            light
            outlined
            dense
            type="number"
            name="amount"
            :label="$t('pages.payments.enterAmount')"
            class="payment-field"
            @input="emitUpdate"
        ></v-text-field>

        <v-text-field
            v-model="localData.due_date"
            :rules="[valid.due_date]"
            light
            outlined
            dense
            type="date"
            name="due_date"
            :label="$t('pages.payments.dueDate')"
            class="payment-field"
            @input="emitUpdate"
        ></v-text-field>
    </div>
</template>

<script>
export default {
    props: {
        amount: {
            type: String,
            default: null,
        },
        due_date: {
            type: String,
            default: '',
        },
        hideFields: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update-payment'],

    data() {
        return {
            localData: {
                amount: this.amount,
                due_date:
                    this.due_date || new Date().toISOString().slice(0, 10),
            },
            valid: {
                amount: (v) => !!v || this.$t('pages.payments.fieldIsRequired'),
                due_date: (v) =>
                    !!v || this.$t('pages.payments.fieldIsRequired'),
            },
        }
    },
    watch: {
        due_date(newValue) {
            this.localData.due_date = newValue
        },
    },
    methods: {
        emitUpdate() {
            this.$emit('update-payment', this.localData)
        },
    },
}
</script>

<style lang="scss">
.transfer-form {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    column-gap: 20px !important;
}
</style>
